/*
* 车辆档案之设备报文组件
* 描述：对应车辆的OBD故障列表，包括查询功能
* 创建时间：2017-03-31
* 创建人：zhanlz
* 修改时间：
*/
<template>
	<div class="pl10px pr10px" v-loading="loadingstatus" element-loading-text="加载中">
		<!--表单部分开始-->
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label focus_color">*设备ID</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.queryParam.deviceId.$error }">
					<select v-model="queryParam.deviceId" class="form-control" >
						<option v-for="item in udcList" :value="item.id">{{item.id}}|{{item.deviceNum}}</option>
					</select>
					<span class="form-group__message cus_message" v-if="!$v.queryParam.deviceId.required && $v.queryParam.deviceId.$error">设备ID为必填项</span>
					<p v-if="!deviceID" class="cus_message form-group__message">设备ID不能为空</p>
				</div>
				<label class="col-sm-1 control-label focus_color">*接收开始时间</label>

				<div class="col-sm-3" v-bind:class="{ 'form-group--error':!enableSubmit }">
					<datepicker class="form-control" v-model="queryParam.createTimeBegin" ref="dateFrom" :options="localeOption"></datepicker>
					<p v-if="!enableSubmit &&!compery" class="cus_message form-group__message">开始时间不得大于结束时间</p>
					<p v-if="compery" class="cus_message form-group__message">应在同一天</p>
				</div>
				<label class="col-sm-1 control-label focus_color">*接收结束时间</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': !enableSubmit }">
					<datepicker class="form-control" v-model="queryParam.createTimeEnd" ref="dateTo" :options="localeOption"></datepicker>
					<p v-if="!enableSubmit &&!compery" class="cus_message form-group__message">开始时间不得大于结束时间</p>
					<p v-if="compery" class="cus_message form-group__message">应在同一天</p>
				</div>

			</div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button v-if="permission.indexOf('fileCarList_deviceMessageReset') == -1" class="btn btn-primary" @click="resetQueryParams">重置</button>
					<button v-if="permission.indexOf('fileCarList_deviceMessageSelect') == -1" class="btn btn-primary" @click="startToSearch" :disabled="!enableSubmit ||!deviceID">查询</button>
				</div>
			</div>
		</div>
		<!--表单部分结束-->
		<!--列表部分开始-->
		<div class="table-responsive">
			<table class="table table-striped table-bordered table-hover">
				<thead>
					<tr role="row">
						<th>设备ID</th>
						<th>设备编码</th>
						<th>设备类型</th>
						<th>接收时间</th>
						<th>定位时间</th>
						<th>报文信息</th>
					</tr>
				</thead>
				<transition-group name="list-complete" tag="tbody">
					<tr v-for="(info,index) in infoList" v-bind:key="index + 'info'" class="list-complete-item">
						<td>VD{{info.deviceId}}</td>
						<td>{{info.deviceNum}}</td>
						<td>{{info.deviceType}}</td>
						<td>{{info.createTime}}</td>
						<td>{{info.gpsTime}}</td>
						<td>{{info.message}}</td>
					</tr>
				</transition-group>

			</table>
		</div>
		<!--列表部分结束-->
		<!--分页组件开始-->
		<pagination
			v-if="infoList.length>0"
			:pageInfo="pageInfo"
			v-on:getData="getPageNo"
			>
		</pagination>
		<!--分页组件结束-->
	</div>
</template>
<script>
	import { zh } from 'flatpickr/dist/l10n/zh'
import Pagination from 'components/common/Pagination'
	import Datepicker from 'components/common/datepicker/Datepicker'
	import { required } from 'vuelidate/lib/validators'
	import { OPERATE_EXCEPTION } from 'static/message'
	import {isNumber} from 'util/util'

	export default {
	  name: 'DetailMessage',
	  components: {
	    Pagination,
	    Datepicker
	  },
	  data () {
	    return {
	      permission: this.$store.state.permission.permission['fileCarList'] ? this.$store.state.permission.permission['fileCarList'] : [],
	      loadingstatus: false,
	      localeOption: {
			        locale: zh,
			        enableTime: true,
			        enableSeconds: true,
			        time_24hr: true
			    },
	      infoList: [],							// 从接口获取的表格数据
	      pageInfo: {},							// 传给分页组件的属性对象
	      pageNo: 1,								// 从分页组件获取的当前页码数
	      compery: false,
				// 以下为查询属性
	      queryParam: {
	        deviceId: '',						// 设备ID
	        createTimeBegin: '',				    // 时间起
	        createTimeEnd: '',					// 时间止
	        page_index: 1
	      },
	      udcList: []
	    }
	  },
	  beforeMount () {
	    let date = new Date()
	    let year = date.getFullYear()
	    let month = ((date.getMonth() + 1) + '').length == 1 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1) + ''
	    let day = ((date.getDate()) + '').length == 1 ? '0' + (date.getDate()) : (date.getDate()) + ''
	    let datestr = year + '-' + month + '-' + day
	    this.queryParam.createTimeBegin = datestr + ' 00:00:00'
	    this.queryParam.createTimeEnd = datestr + ' 23:59:59'
	    this.getUdc()
	  },
	  validations: {
	    queryParam: {
	      deviceId: {
		    		required
		   		},
		   		createTimeBegin: {
		    		required
		   		},
		   		createTimeEnd: {
		    		required
		   		}
	    }
	  },
	  computed: {
	    enableSubmit: function () {
	      if ((this.queryParam.createTimeBegin).substr(0, 10) !== (this.queryParam.createTimeEnd).substr(0, 10)) {
	        this.compery = true
	        return false
	      }			else {
	        this.compery = false
	      }
	      if (this.queryParam.createTimeBegin > this.queryParam.createTimeEnd) {
	        return false
	      }			else {
				      return true
	      }
	    },
	    deviceID: function () {
	      if (!this.$v.queryParam.deviceId.required) {
	        return false
	      } else {
	        return true
	      }
	    }
	  },
	  methods: {
			// 获取OBD故障信息
	    getTableInfo () {
	      let queryParamTemp = Object.assign({}, this.queryParam)
	      queryParamTemp.deviceId = queryParamTemp.deviceId
	      this.loadingstatus = true
	      this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/devices/gps-log', {params: queryParamTemp})
					.then((response) => {
	  if (response.body.success) {
	    const resInfo = response.body
	    if (resInfo.data.list.length == 0) {
	      this.loadingstatus = false
	      return
    }
	    const {pageNum, pages, total, isFirstPage, isLastPage} = resInfo.data
	    this.pageInfo = {
	      pageNum: pageNum,
	      pages: pages,
	      total: total,
	      isFirstPage: isFirstPage,
	      isLastPage: isLastPage
	    }
	    this.infoList = resInfo.data.list
	  } else {
	    this.$parent.openModal(response.body.message)
	  }
	  this.loadingstatus = false
	}, (response) => {
	  this.$parent.openModal(response.body.message)
	  this.loadingstatus = false
	})
					.catch((response) => {
	  this.$parent.openModal(OPERATE_EXCEPTION)
	  this.loadingstatus = false
	})
	    },
	    getUdc () {
	      this.loadingstatus = true
	      let para = {}
	      this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/' + this.$parent.vehicleInfo.vehicleId + '/devices/list')
					.then((response) => {
	  if (response.body.success) {
	    this.udcList = response.body.data
	    this.queryParam.deviceId = this.udcList[0].id
	    this.startToSearch()
	  } else {
	    this.$parent.openModal(response.body.message)
	  }
	  this.loadingstatus = false
	}, (response) => {
	  this.$parent.openModal(response.body.message)
	  this.loadingstatus = false
	})
					.catch((response) => {
	  this.$parent.openModal(OPERATE_EXCEPTION)
	  this.loadingstatus = false
	})
	    },
			// 从分页组件获取页码参数
	    getPageNo (pageNo) {
	      this.pageNo = pageNo
	      this.queryParam.page_index = pageNo
	      this.getTableInfo()
	    },
	    startToSearch () {
	      let strid = this.queryParam.deviceId
	      if (!isNumber(strid)) {
	        this.$parent.openModal('设备ID输入有误')
	        return
      }
	      this.getTableInfo()
	    },
	    resetQueryParams: function () {
	      this.$refs.dateFrom.handleClear()
	      this.$refs.dateTo.handleClear()
	      this.queryParam = {
	        deviceId: '',						// 设备ID
	        createTimeBegin: '',				    // 时间起
	        createTimeEnd: ''					// 时间止
	      }
	    }
	  }
	}
</script>



// WEBPACK FOOTER //
// DetailMessage.vue?78260ba4